import SpriteSymbol from "../../../../node_modules/.store/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.store/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-x",
  "use": "icon-x-usage",
  "viewBox": "0 0 7 6",
  "content": "<symbol viewBox=\"0 0 7 6\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-x\">\n\t<path d=\"M5.48926 0.279297L6.07471 0.854004L1.57373 5.56982L0.988281 4.99512L5.48926 0.279297ZM0.988281 0.854004L1.57373 0.279297L6.07471 4.99512L5.48926 5.56982L0.988281 0.854004Z\" fill=\"#9D9D9D\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol